import * as React from 'react';
import { AddButton, CloseButton, InfoText, Textarea, ValidationProps } from 'ui';
import { CodeListItem, ImportMapping, ImportMappingType } from 'app/area/import-mappings/types-store';
import { MdAdd, MdDelete } from 'react-icons/md';
import { Button } from 'ui/common/button/button';
import { getCurrentImportCodeValidation } from 'app/area/import-mappings/validation';
import { ImportMappingsTranslation, externalValueMaxLength } from 'app/area/import-mappings/constants';
import { deleteImportMapping, setImportMapping } from './current-import-code-mapping';
import { removeAllEnters, removeImportMapping } from 'app/area/import-mappings/list-items/modify-import-code';
import styles from './current-import-code.scss';

interface CurrentImportCodeProps {
  currentCode: CodeListItem;
  updating: boolean;
  importMapping: ImportMapping[];
  validation: { [key: string]: ValidationProps };
  translation: ImportMappingsTranslation;
  modifyImportMapping: (modifiedImportMapping: ImportMapping[]) => void;
  clearCurrentCode: () => void;
  clearValidation: () => void;
  setCurrentCode: (data: CodeListItem) => void;
}

export class CurrentImportCode extends React.PureComponent<CurrentImportCodeProps> {

  private onSetImportMapping = (index: number) => {
    return (newExternalValue: string) => {
      if (!this.props.updating) {
        this.props.modifyImportMapping(
          setImportMapping(index, newExternalValue, [...this.props.currentCode.importMapping])
        );
      }
    };
  };

  private onDeleteImportMapping = (index: number, importMapping: ImportMapping) => {
    return () => {
      if (!importMapping.importNumber) {
        this.props.setCurrentCode({
          ...this.props.currentCode,
          importMapping: removeImportMapping(index, this.props.currentCode.importMapping)
        });
      } else {
        const modifyImportMapping = deleteImportMapping(index, importMapping, [...this.props.currentCode.importMapping]);
        this.props.modifyImportMapping(modifyImportMapping);
      }
    };
  };

  private onAddNewImportMapping = (e: React.SyntheticEvent) => {
    e.preventDefault();

    this.props.setCurrentCode({
      ...this.props.currentCode,
      importMapping: [
        ...this.props.currentCode.importMapping,
        { importNumber: undefined, externalValue: '', type: ImportMappingType.New }
      ]
    });
  };

  private hasNewField = () => this.props.currentCode.importMapping.some(mapping => mapping.type === ImportMappingType.New
    || (mapping.externalValue === '' && mapping.existingExternalValue === ''));

  public render() {
    const { currentCode, clearCurrentCode, updating, validation, translation } = this.props;

    return <div className={styles.listContainer}>
      <div className={styles.listHolder}>
        <div className={styles.listItems}>
          <div className={`row flex-nowrap justify-content-between ${styles.expanderHeader} has-title dialog-expander-header`}>
            <div className={`col ${styles.title}`}>
              {translation.import_code} <InfoText
                visible={true}
                text={translation.import_code_info}
              />
            </div>
            <div className={` col col-auto ${styles.expanderCloseX} expander-close-x`}>
              <div className="d-flex">
                <CloseButton onClick={clearCurrentCode} autofocus={false} />
              </div>
            </div>
          </div>
          <div>
            {currentCode.importMapping.map((item, index) =>
              item.type !== ImportMappingType.Deleted
                ? <div key={index} className={styles.importCodeItem}>
                  <Textarea
                    className="w-100"
                    label={undefined}
                    value={item.externalValue}
                    maxLength={externalValueMaxLength}
                    onChange={((i) => this.onSetImportMapping(i))(index)}
                    validation={getCurrentImportCodeValidation(item.importNumber, currentCode?.codetableId, currentCode?.id,
                      removeAllEnters(item.externalValue), validation?.importCode)}
                    wait={500} />
                  <Button
                    disabled={updating}
                    btnType={styles.removeWrapper}
                    onClick={() => this.onDeleteImportMapping(index, item)()}>
                    <MdDelete className={styles.removeIcon} />
                  </Button>
                </div> : null
            )}
          </div>
          <div className={styles.addCode}>
            <AddButton icon={MdAdd} onClick={this.onAddNewImportMapping} disabled={updating || this.hasNewField()}>
              {translation.add_code}
            </AddButton>
          </div>
        </div>
      </div>
    </div>;
  }
}
